import sdl from '@jds/react-generated-sdl/JDSCarouselPaginationItem';
import type { JDSCarouselPaginationItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSCarouselPaginationItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'normal',
    density = 'relaxed',
    active = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, density, active, ...rest },
    'JDSCarouselPaginationItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const CarouselPaginationItem = withLogic(
  Component
) as React.FC<JDSCarouselPaginationItemProps> & { slotName?: string };

CarouselPaginationItem.displayName = 'CarouselPaginationItem';
CarouselPaginationItem.slotName = 'jds_carousel_pagination_item';

export { CarouselPaginationItem, type JDSCarouselPaginationItemProps };
